import { useTranslation } from '../i18n';
import type { Lang } from '../i18n/types';

const LANGS: { code: Lang; label: string }[] = [
  { code: 'vi', label: 'Vietnamese' },
  { code: 'en', label: 'EN' },
  { code: 'ja', label: '日本語' },
  { code: 'ko', label: '한국어' },
];

export default function LanguageSwitcher() {
  const { lang, setLang } = useTranslation();
  return (
    <div className="lang-switcher">
      {LANGS.map(l => (
        <button
          key={l.code}
          className={`lang-btn${lang === l.code ? ' active' : ''}`}
          onClick={() => setLang(l.code)}
        >
          {l.label}
        </button>
      ))}
    </div>
  );
}
